const commomPermissions = [process.env.VUE_APP_ADMINISTRADOR, process.env.VUE_APP_CALLCENTER_MONITOR_TOTAL]

export const arrayPermissaoAcesso = [...commomPermissions, process.env.VUE_APP_CALLCENTER_MONITOR_VISUALIZAR]

export const arrayPermissaoPausaDespausa = [...commomPermissions, process.env.VUE_APP_CALLCENTER_MONITOR_PAUSA_DESPAUSA]

export const arrayPermissaoAdicionarRemover = [
  ...commomPermissions,
  process.env.VUE_APP_CALLCENTER_MONITOR_ADICIONAR_REMOVER_OPERADOR,
]

export const arrayPermissaoDeslogarOperador = [
  ...commomPermissions,
  process.env.VUE_APP_CALLCENTER_MONITOR_DESLOGAR_OPERADOR,
]

export const arrayPermissaoOuvirOperador = [...commomPermissions, process.env.VUE_APP_CALLCENTER_MONITOR_OUVIR_OPERADOR]
